import { type Translation } from "./en";

export const es: Translation = {
  ai_speech_preview_free_title: "Voz estándar",
  ai_speech_preview_free_desc: "Voz robótica gratuita",
  ai_speech_preview_pro_desc: "Voz de alta calidad con entonación natural",
  ai_speech_preview_free_lbl: "Gratis",
  ai_speech_lang_support: "Soporta más de 30 idiomas",
  ai_speech_listen: "Escuchar muestra",
  voice_type_none: "Ninguno",
  review_custom: "Seleccionar qué revisar",
  review_card_type: "Tipo de tarjeta",
  custom_due_cards: "Tarjetas por revisar",
  custom_new_cards: "Tarjetas nuevas",
  settings_lang: "Idioma",
  html_row: "Fila",
  html_column: "Columna",
  copied: "Copiado",
  copy_code: "Copiar código",
  logout: "Cerrar sesión",
  browser_no_personal_decks_link: "Aprende cómo usar MemoCard en ",
  browser_no_personal_decks_end: ". ¡Buena suerte! 😊",
  browser_no_personal_decks_start: "No tienes mazos personales todavía",
  error_contact_support:
    "Se ha producido un error. Por favor, contacta con soporte para que podamos ayudarte.",
  ai_card_input_mode_supports: "Soporta diferentes idiomas",
  upgrade_pro: "Obtener Pro",
  login_google: "Iniciar sesión con Google",
  youtube_channel: "Canal de YouTube",
  card_input_mode_changed: "Modo de entrada de tarjeta cambiado",
  card_input_mode_type: "Si escribes",
  card_input_mode_get: "obtendrás la tarjeta",
  card_input_mode_manual: "Entrada manual",
  generate: "Generar",
  card_input_mode_screen: "Modo de entrada de tarjeta",
  yes: "Sí",
  ai_speech_validate: "Por favor, selecciona una cara o escribe el texto",
  ai_speech_type: "O escribe el texto necesario",
  ai_speech_empty:
    "No se ha generado ninguna voz de IA. Elige el lado de la tarjeta a continuación.",
  ai_speech_title: "Voz de IA",
  ai_speech_generate: "Generar",
  confirm_ok: "Confirmar",
  confirm_cancel: "Cancelar",
  payment_success:
    "El pago se ha realizado con éxito. Disfruta de las funciones adicionales 😊",
  payment_failed:
    "El pago ha fallado. Estamos al tanto del problema y trabajando en ello. Por favor, contacta con soporte a través de Configuración > Soporte",
  user_settings_updated: "Configuración actualizada",
  is_off: "Apagado",
  is_on: "Encendido",
  folder_form_no_decks: "No hay mazos en la carpeta",
  card_next: "Siguiente",
  card_previous: "Anterior",
  ui_loading: "Cargando...",
  yes_no: "Recordar",
  card_answer_type: "Tipo de tarjeta",
  answer_type_explanation_choice: `Una tarjeta con opciones de respuesta`,
  answer_type_explanation_remember: `Una tarjeta con botones "Recordar" y "No recordar"`,
  answer_type_choice: "Elección",
  profile_section: "Perfil",
  folder_form_quit_card_confirm: "¿Salir sin guardar la carpeta?",
  read_more: "Leer más",
  review_idk: "No sé",
  review_again: "Otra vez",
  review_hard: "Difícil",
  review_good: "Bien",
  review_easy: "Fácil",
  user_stats_empty_text: "Estudia más tarjetas para ver los datos",
  hide_card_forever: "Ocultar para siempre",
  mute_cards: "Silenciar sonido",
  unmute_cards: "Activar sonido",
  hide_card_forever_confirm_title:
    "¿Estás seguro de que quieres ocultar esta tarjeta para siempre? No la volverás a ver",
  next: "Siguiente",
  payment_tos_and_pp_agree: "Al comprar MemoCard aceptas los ",
  payment_pp: "Política de privacidad",
  privacy_policy: "Política de privacidad",
  payment_and: " y ",
  payment_tos: "Términos de servicio",
  payment_paid_until: "Pagado hasta",
  payment_description: "Desbloquea más funciones",
  payment_choose_duration: "Elige la duración",
  payment_method_usd: "Tarjeta de crédito",
  payment_choose_method: "Método de pago",
  payment_choose_subscription: "Suscripción",
  payment_method_stars: "Estrellas de Telegram",
  payment_included: "Qué está incluido",
  ai_cards_left: "Tarjetas de IA restantes este mes",
  wysiwyg_bold: "Negrita",
  wysiwyg_undo: "Deshacer",
  repeat_cards_anyway: `Repetir de todos modos`,
  wysiwyg_big_header: "Encabezado grande",
  wysiwyg_text_color: "Color de texto",
  wysiwyg_clear_formatting: "Borrar formato",
  wysiwyg_italic: "Cursiva",
  formatting: "Formato",
  validation_at_least_one_deck: "Por favor, selecciona al menos 1 mazo",
  duplicate_folder_confirm: "¿Estás seguro de duplicar esta carpeta?",
  validation_at_least_one_answer_required:
    "Se debe proporcionar al menos una respuesta",
  validation_answer_at_least_one_correct:
    "Se debe seleccionar al menos una respuesta correcta",
  review_correct_label: "Correcto",
  review_wrong_label: "Incorrecto",
  advanced: "Avanzado",
  answer_text: "Texto de la respuesta",
  add_answer: "Añadir respuesta",
  card_preview: "Vista previa",
  review_folder: "Repasar carpeta",
  folder_description: "Una colección de mazos",
  add_deck_short: "Mazo",
  folder: "Carpeta",
  deck_description: "Una colección de tarjetas",
  deck: "Mazo",
  edit_folder: "Editar carpeta",
  add_folder: "Añadir carpeta",
  add_deck_to_folder: "Añadir mazo a la carpeta",
  decks_in_other_folders: "Mazos en otras carpetas",
  no_decks_to_add: "No hay más mazos para añadir",
  decks: "Mazos",
  my_decks: "Mis mazos",
  show_all_decks: "Mostrar todos",
  hide_all_decks: "Ocultar",
  select_all: "Seleccionar todo",
  deselect_all: "Deseleccionar todo",
  select: "Seleccionar",
  selected: "Seleccionado",
  add_deck: "Añadir mazo",
  deck_form_remove_card_confirm:
    "¿Estás seguro de que quieres eliminar la tarjeta? Todas las revisiones de tarjetas de todos los usuarios se perderán",
  deck_form_remove_cards_confirm:
    "¿Estás seguro de que quieres eliminar todas las tarjetas seleccionadas?",
  edit_deck: "Editar mazo",
  edit_card: "Editar tarjeta",
  add: "Añadir",
  edit: "Editar",
  view: "Ver",
  all_decks_reviewed: `¡Increíble trabajo! 🌟 Has repasado todos los mazos por ahora. Vuelve más tarde para más.`,
  public_decks: "Mazos públicos",
  explore_public_decks: "Explorar más mazos",
  news_and_updates: "Noticias y actualizaciones",
  telegram_channel: "Canal de Telegram",
  settings: "Configuración",
  deck_has_been_added: "Este mazo está en tu lista",
  deck_catalog: "Catálogo de Mazos",
  translated_to: "Traducido a",
  any_language: "Cualquier idioma",
  category: "Categoría",
  any_category: "Cualquiera",
  deck_search_not_found: "No se encontraron mazos",
  card_search_not_found: "No se encontraron tarjetas",
  deck_search_not_found_description:
    "Intenta actualizar los filtros para ver más mazos",
  category_English: "Inglés",
  category_Other: "Otro",
  category_Thai: "Tailandés",
  category_Geography: "Geografía",
  category_History: "Historia",
  category_Chemistry: "Química",
  category_Spanish: "Español",
  save: "Guardar",
  add_card: "Añadir tarjeta",
  add_card_short: "Añadir",
  card_front_title: "Cara frontal",
  card_back_title: "Cara posterior",
  card_front_side_hint: "La pregunta o indicación",
  card_back_side_hint: "La respuesta que necesitas proporcionar",
  card_field_example_title: "Ejemplo",
  card_field_example_hint: "Información adicional opcional",
  cards: "Tarjetas",
  search_card: "Buscar tarjeta",
  card_sort_by_date: "Fecha",
  card_sort_by_front: "Frente",
  card_sort_by_back: "Dorso",
  sort_by: "Ordenar por",
  title: "Título",
  description: "Descripción",
  speaking_cards: "Tarjetas habladas",
  voice_language: "Idioma de voz",
  card_speak_side: "Lado de la tarjeta",
  front: "Frente",
  back: "Dorso",
  card_speak_description:
    "Reproducir audio hablado para cada tarjeta de memoria para escuchar la pronunciación.",
  review_deck_finished: `Has terminado este mazo por ahora 🎉`,
  review_all_cards: `Has repasado todas las tarjetas por hoy 🎉`,
  review_finished_want_more: "¿Quieres más? Tienes",
  review_finished_to_review: "para estudiar",
  review_deck: "Repasar mazo",
  cards_to_repeat: "Para repetir",
  cards_new: "Nuevas tarjetas",
  cards_total: "Total de tarjetas",
  duplicate: "Duplicar",
  duplicate_deck_confirm: "¿Estás seguro de duplicar este mazo?",
  delete_deck_confirm_shared: "¿Eliminar el mazo de tu colección?",
  delete_folder_confirm_author:
    "¿Eliminar la carpeta de MemoCard? Esta acción no se puede deshacer",
  delete_folder_confirm_shared: "¿Eliminar la carpeta de tu colección?",
  delete_deck_confirm_author:
    "¿Eliminar el mazo de MemoCard? Esta acción no se puede deshacer",
  delete: "Eliminar",
  no_cards_to_review_in_deck: `¡Increíble trabajo! 🌟 Has repasado todas las tarjetas en este mazo por ahora. Vuelve más tarde para más.`,
  no_cards_to_review_all: `¡Increíble trabajo! 🌟 Has repasado todas las tarjetas por hoy. Vuelve más tarde para más.`,
  review_show_answer: "Mostrar respuesta",
  share: "Compartir",
  warning_telegram_outdated_title: "Tu Telegram está desactualizado",
  warning_telegram_outdated_description:
    "Por favor, actualiza tu Telegram para asegurar el funcionamiento estable de esta aplicación.",
  settings_review_notifications: "Notificaciones de repaso",
  settings_time: "Hora",
  settings_review_notifications_hint:
    "Los recordatorios diarios te ayudan a recordar repetir las tarjetas",
  validation_deck_title: "El título del mazo es obligatorio",
  deck_form_quit_card_confirm: "¿Salir sin guardar la tarjeta?",
  deck_form_quit_deck_confirm: "¿Salir sin guardar el mazo?",
  deck_category: "Categoría del mazo",
  validation_required: "Este campo es obligatorio",
  share_link_copied: "El enlace se ha copiado en el portapapeles",
  settings_support_hint: "Si tienes algún problema, pregunta o sugerencia",
  settings_contact_support: "Contactar con soporte en Telegram",
  go_back: "Volver",
  user_stats_btn: "Estadísticas",
  user_stats_page: "Mi estadística",
  user_stats_remembered: "Tarjetas recordadas",
  user_stats_remembered_hint: "Presionado 'Recuerdo' 5 veces seguidas",
  user_stats_learning: "En proceso de aprendizaje",
  user_stats_learning_hint: "Presionado 'Recuerdo' menos de 5 veces seguidas",
  user_stats_total: "Total de tarjetas",
  user_stats_total_hint: "Tarjetas abiertas al menos una vez",
  user_stats_learning_time: "Distribución del tiempo de aprendizaje",
  user_stats_learning_time_hint:
    "Cómo se distribuye tu tiempo entre el aprendizaje de material nuevo y la revisión",
  user_stats_chart_max_expl: "Conozco la tarjeta muy bien",
  user_stats_chart_min_expl: "No conozco la tarjeta",
  validate_under_100: "Por favor, introduce un número menor que 100",
  validate_positive: "Por favor, introduce un número positivo",
  freeze_confirm_freeze:
    "¿Estás seguro de que quieres congelar tus tarjetas? Esta acción no se puede deshacer.",
  freeze_for: "Congelar durante",
  freeze_for_or_manual: "o escribe manualmente",
  how: "Cómo funciona",
  freeze_rule_1:
    "Todas tus tarjetas se pausarán y no recibirás notificaciones.",
  freeze_rule_2:
    "La cantidad de tarjetas a revisar no aumentará durante el período congelado; verás el mismo número de tarjetas cuando reanudes.",
  freeze_notified: "Recibirás una notificación",
  freeze_rule_4:
    "Si añades una tarjeta durante el período de congelación, no se verá afectada por la congelación.",
  freeze_rule_3: "La congelación de tarjetas no se puede deshacer.",
  freeze_title: "Congelar tarjetas",
  freeze_hint: "Posponer el estudio de las tarjetas",
  error_solving: "Estamos resolviendo el problema",
  ai_cards_title: "Creación de tarjetas con IA",
  ai_cards_no_previous_prompts: "No hay solicitudes previas",
  ai_cards_confirm_delete: "¿Eliminar esta tarjeta?",
  ai_cards_by_ai: "Tarjetas generadas",
  ai_cards_generate: "Generar tarjetas",
  ai_cards_prompt: "Descripción del mazo",
  ai_cards_use_template: "Usar plantilla",
  ai_cards_previous_prompts: "Historial de solicitudes",
  ai_cards_prompt_front: "Cara de la tarjeta",
  ai_cards_prompt_back: "Dorso de la tarjeta",
  quit_without_saving: "¿Salir sin guardar?",
  ai_cards_added: "Tarjetas añadidas",
  error: "Error",
  cards_add: "Añadir tarjeta",

  // Global Search
  global_search_placeholder: "Buscar mazos, carpetas, tarjetas",
  global_search_no_results: "No se encontraron resultados",
  global_search_cancel: "Cancelar",
  global_search_start_typing:
    "Comienza a escribir para buscar mazos, carpetas y tarjetas",
  global_search_tabs_cards: "Tarjetas",
  global_search_tabs_decks: "Mazos",
  global_search_tabs_folders: "Carpetas",
  global_search_context_folder: "Carpeta",
  global_search_context_deck: "Mazo",

  // About page
  about_title: "Acerca de",
  about_paragraph_1:
    "MemoCard existe porque apps como Anki son un dolor de cabeza. Sí, son potentes, pero hay que configurar mil cosas, no te avisan cuando repasar y parecen de los 90.",
  about_paragraph_2:
    "En el concurso de Mini Apps de Telegram hice la app de tarjetas que siempre quise. No hay que configurar nada, los recordatorios ya funcionan y todo es simple.",
  about_paragraph_3:
    "Usa el método científico de repetición espaciada de Ebbinghaus. Las tarjetas aparecen justo cuando empiezas a olvidar - así es como mejor se memoriza.",
  about_paragraph_4:
    "MemoCard ganó premio en el concurso. Ahora lo usan miles de personas en todo el mundo.",
  about_visit_website: "Visitar sitio web →",
  about_github_frontend: "Repositorio de GitHub del frontend →",

  // Card Input Mode Form
  card_input_mode_form_title: "Título",
  card_input_mode_form_ai_prompt: "Prompt de IA",
  card_input_mode_form_create_title: "Crear modo de entrada",
  card_input_mode_form_edit_title: "Editar modo de entrada",
  card_input_mode_form_delete_confirm: "¿Eliminar este modo de entrada?",
  card_input_mode_add_button: "Agregar modo de entrada",
  card_input_mode_form_title_placeholder: "ej. Definiciones en Inglés",
  card_input_mode_form_prompt_placeholder:
    "ej. Genera una tarjeta de definición para la palabra :template_word",
  card_input_mode_form_front_placeholder: "ej. Palabra o término",
  card_input_mode_form_back_placeholder: "ej. Definición simple",
  card_input_mode_form_example_placeholder: "ej. Ejemplo de uso o contexto",
  card_input_mode_form_save_success: "Modo de entrada guardado",
  card_input_mode_form_delete_success: "Modo de entrada eliminado",
  quit_card: "Salir de la tarjeta",

  // Wysiwyg Help
  wysiwyg_help_title: "Guía de formato de texto",
  wysiwyg_help_step1: "Resalta el texto que quieres cambiar",
  wysiwyg_help_step2: "Presiona cualquier botón de la barra de herramientas",
  wysiwyg_help_bold: "Texto en negrita",
  wysiwyg_help_italic: "Texto en cursiva",
  wysiwyg_help_color: "Cambiar color del texto",
  wysiwyg_help_heading: "Hacer el texto más grande (encabezado)",
  wysiwyg_help_table: "Insertar una tabla",
  wysiwyg_help_clear: "Quitar todo el formato",
  wysiwyg_help_undo: "Deshacer última acción",

  reverse_cards: "Tarjetas inversas",
  reverse_cards_title: "Tarjetas Inversas",
  reverse_cards_helper: "Crea una y obtén dos. Ayuda a recordar mejor",
  two_cards_created: "Se han creado 2 tarjetas",
  card_created: "Tarjeta creada",

  // Move card to deck
  move_card_to_deck_title: "Mover a mazo",
  move_card_without_folder: "Sin carpeta",
  move_card_move: "Mover",
  move_card_open_deck: "Abrir mazo",

  // Image related
  image: "Imagen",

  // Skip card
  skip_card_for_now: "Saltar por ahora",
  skip_card_confirm: "¿Saltar esta tarjeta? Estará oculta hasta tu próximo repaso",
  review_skipped: "Saltada",
};
